import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero-background.png"
          alt="Luxury Snooker Table"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-5xl mx-auto px-6">
        {/* Logo Wordmark */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-8"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_28b33ae7-3c8b-44fa-9343-f9f615e11717/artifacts/p03aed6e_Wordmark.png"
            alt="Centurio Prime Wordmark"
            className="mx-auto h-32 md:h-44 object-contain"
            data-testid="hero-logo"
          />
        </motion.div>

        {/* Main Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="hero-title font-cinzel text-5xl md:text-7xl font-bold text-gold mb-6 tracking-wider text-shadow-gold"
          data-testid="hero-headline"
        >
          Where Precision Meets Prestige
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="font-montserrat text-lg md:text-2xl text-neutral-300 mb-12 font-light leading-relaxed"
          data-testid="hero-subheadline"
        >
          Experience Elite Snooker in an Atmosphere of Luxury
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
        >
          <button
            onClick={scrollToBooking}
            className="btn-primary gold-glow-hover"
            data-testid="hero-reserve-button"
          >
            Reserve Your Table
          </button>
          <a
            href="tel:+923016697234"
            className="btn-outline gold-glow-hover"
            data-testid="hero-call-button"
          >
            Call Now
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-gold rounded-full flex items-start justify-center p-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-gold rounded-full"
          ></motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
